import invariant from 'invariant';
import React from 'react';

import { Subsite } from 'api/website';
import { FilestackImage } from 'components/Image';
import { isDefined, randomInt } from 'utils/functional';

const randomElement = (arr) => arr[randomInt(arr.length)];

const makeKey = (id) => `placeholderImg:${id}`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const PlaceholderPostImage = ({
  postId,
  subsite,
  ...props
}: {
  postId: string;
  subsite: Subsite;
  alt: string;
  height: number;
  width: number;
  fit: string;
  round?: boolean;
  'data-qa-id'?: string;
  className?: string;
}) => {
  invariant(
    isDefined(localStorage),
    'Placeholder image uses local storage (browser)'
  );
  const storedHandle = localStorage.getItem(makeKey(postId));
  const randomItem = randomElement(subsite.placeholderImages);

  const image =
    subsite.placeholderImages.find((i) => i.handle === storedHandle) ||
    (() => {
      localStorage.setItem(makeKey(postId), randomItem.handle);
      return randomItem;
    })();

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <FilestackImage {...props} data={image} />;
};

export default PlaceholderPostImage;
